import { createModel } from "nyax";
import { CoeMyWork, CoeMyWorkQuery } from "src/models/coeMyWork";
import { CoeMyWorkEntityModel } from "src/store/models/entity/coeMyWork/entity";
import { createUISideListWithPermissionModel } from "src/store/models/ui/_shared";

export const CoeMyWorkSideUIModel = createModel(
  class extends createUISideListWithPermissionModel<CoeMyWork, CoeMyWorkQuery>({
    setItems: (getContainer, items) =>
      getContainer(CoeMyWorkEntityModel).actions.setItems.dispatch(items),
    getItems: (getContainer) =>
      getContainer(CoeMyWorkEntityModel).getters.items,
    getItem: (getContainer, id) =>
      getContainer(CoeMyWorkEntityModel).state.byId[id],
    getItemId: (item) => item.id,
  }) {
    public effects() {
      return {
        ...super.effects(),
        initial: async (payload: { departmentId: string }) => {
          const { departmentId } = payload;
          this._initial({
            initialAction: (
              pageIndex: number,
              pageSize: number,
              query: CoeMyWorkQuery
            ) =>
              this.dependencies.serviceClient.coeWork.myList(
                departmentId,
                pageIndex,
                pageSize,
                query
              ),
          });
        },
      };
    }
  }
);
